import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import HomePage from './pages/index'
import LoginPage from './pages/login'
import DashboardPage from './pages/dashboard/index'
import CoursePage from './pages/course/index'
import SuccessPage from './pages/success/index'
import PrivacyPage from './pages/privacy/index'
import UniversityPage from './pages/university/index'
import CheckoutPage from './pages/checkout'
import UniversityTermsPage from './pages/university/terms'
import NotFoundPage from './pages/404'

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/course" element={<CoursePage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        {/* A linkable purchase URL. The tier is a path segment so each is its
            own URL; ?tier= is accepted in checkout.tsx and redirects here. */}
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/:tier" element={<CheckoutPage />} />
        <Route path="/university" element={<UniversityPage />} />
        <Route path="/university/terms" element={<UniversityTermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--color-bg-secondary)',
            color: 'var(--color-text-primary)',
            border: '1px solid var(--color-border-primary)',
          },
        }}
      />
    </>
  )
}

export default App